module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "min-h-dvh flex flex-col"
  }, [_c('app-menu'), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('bottom-menu')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0958c6eb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 1000
// module chunks = 0